(function() {
    'use strict';

    angular
        .module('iMatApp')
        .directive('imageEvents', imageEventsDirective);

    imageEventsDirective.$inject = ['$parse'];
    
    function imageEventsDirective($parse) {
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            var loadFn = $parse(attrs.imageLoad);
            element.on('load', function (event) {
                scope.$apply(function () {
                    loadFn(scope, { $event: event });
                });
            });
            
            var errorFn = $parse(attrs.imageError);
            element.on('error', function (event) {
                scope.$apply(function () {
                    errorFn(scope, { $event: event });
                });
            });

            scope.$on("$destroy", function () {
                element.off('load');
                 element.off('error');
            });
        }
    }

})();